import { FormatConstants } from "services/keyConstants";

export const getStatusTypes = (type) => {
  switch (type) {
    case FormatConstants.NON_CONFORMING_OF_PRODUCT.NON_CONFORMING_PRODUCT_REGISTER:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          documentName: FormatConstants.NON_CONFORMING_OF_PRODUCT.NON_CONFORMING_PRODUCT_REGISTER,
          revisionNumber: "",
          type: "In-Process Inspection"
        },
        defaultOptionData: {
          statusOptions: [
            { label: 'Pending', value: 'Pending' },
            { label: "Completed", value: "Completed" },
          ],
          typeOptionData: [
            { label: "Incoming inspection report", value: "In-coming Inspection" },
            { label: "In-Process Inspection", value: "In-Process Inspection" },
            { label: 'Final inspection report', value: 'Final Inspection' },
          ]
        }
      };
      break;

    case FormatConstants.NON_CONFORMING_OF_PRODUCT.NON_CONFORMING_OF_PRODUCT:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          documentName: FormatConstants.NON_CONFORMING_OF_PRODUCT.NON_CONFORMING_OF_PRODUCT, 
          revisionNumber: "",
          type: "In-Process Inspection"
        },
        defaultOptionData: {
          statusOptions: [
            { label: 'Approved', value: 'Approved' },
            { label: "Initiated", value: "Initiated" },
          ],
          typeOptionData: [
            { label: "Incoming inspection report", value: "In-coming Inspection" },
            { label: "In-Process Inspection", value: "In-Process Inspection" },
            { label: 'Final inspection report', value: 'Final Inspection' },
          ]
        }
      };
      break;

    case FormatConstants.NON_CONFORMING_OF_PRODUCT.REJECTION_RECORD:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          documentName: FormatConstants.NON_CONFORMING_OF_PRODUCT.REJECTION_RECORD,
          revisionNumber: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: 'Pending', value: 'Pending' },
            { label: "Submitted", value: "Submitted" },
          ],
        }
      };
      break;
    case FormatConstants.NON_CONFORMING_OF_PRODUCT.REWORK_RECORD:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          documentName: FormatConstants.NON_CONFORMING_OF_PRODUCT.REWORK_RECORD,
          revisionNumber: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: 'Pending', value: 'Pending' },
            { label: "Submitted", value: "Submitted" },
          ],
        }
      };
      break;
    case FormatConstants.NON_CONFORMING_OF_PRODUCT.RETURN_RECORD:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          documentName: FormatConstants.NON_CONFORMING_OF_PRODUCT.RETURN_RECORD,
          revisionNumber: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: 'Pending', value: 'Pending' },
            { label: "Submitted", value: "Submitted" },
          ],
        }
      };
      break;
    case FormatConstants.NON_CONFORMING_OF_PRODUCT.CONCESSION_RECORD:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          documentName: FormatConstants.NON_CONFORMING_OF_PRODUCT.CONCESSION_RECORD,
          revisionNumber: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: 'Pending', value: 'Pending' },
            { label: "Submitted", value: "Submitted" },
          ],
        }
      };
      break;
    case FormatConstants.NON_CONFORMING_OF_PRODUCT.SCRAP_RECORD:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          documentName: FormatConstants.NON_CONFORMING_OF_PRODUCT.SCRAP_RECORD,
          revisionNumber: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: 'Pending', value: 'Pending' },
            { label: "Submitted", value: "Submitted" },
          ],
        }
      };
      break;

    // Default case if no matching type is found
    default:
      return {
        filteredData: {
          orderStatus: "Unknown",
          status: "Unknown",
          documentName: "Unknown Document",
        },
        defaultOptionData: {
          statusOptions: []
        }
      };
  }
};